import React from 'react'
import {FormattedMessage} from 'react-intl';

const TableHead = ({applySort, actionCallback}) => {
  return (
    <thead className="thead-light">
    <tr>
      <th
        className="sort"
        data-sort="first_name"
        scope="col"
        onClick={() => applySort('first_name')}
      >
        <FormattedMessage
          id="components.pages.users.usersTable.table.first_name"/>
      </th>

      <th
        className="sort"
        data-sort="last_name"
        scope="col"
        onClick={() => applySort('last_name')}
      >
        <FormattedMessage
          id="components.pages.users.usersTable.table.last_name"/>
      </th>

      <th
        className="sort"
        data-sort="email"
        scope="col"
        onClick={() => applySort('email')}
      >
        <FormattedMessage
          id="components.pages.users.usersTable.table.email"/>
      </th>

      <th scope="col">
        <FormattedMessage id="components.pages.users.usersTable.table.actions"/>
      </th>
    </tr>
    </thead>
  )
}

export {
  TableHead
}
